import apiClient from './apiClient';

export async function submitTrialExtensionRequest(payload) {
  const response = await apiClient.post('/trial-extension', payload, {
    suppressGlobalErrorToast: true,
  });
  return response.data;
}
